import { render, staticRenderFns } from "./TagInput.vue?vue&type=template&id=43b5f986&"
import script from "./TagInput.vue?vue&type=script&lang=ts&"
export * from "./TagInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports